import { useCallback } from 'react'
import { useSWRConfig } from 'swr'
import { ACTIVE_ORDER_KEY } from '@lib/api/cart/useCart'
import { SetOrderShippingAddressMutationVariables } from '@lib/api/vendureGraphql'
import { getSdk } from '../utils/sdk'

export const useSetOrderShippingAddress = () => {
  const { mutate } = useSWRConfig()

  const setOrderShippingAddress = useCallback(
    async (input: SetOrderShippingAddressMutationVariables) => {
      const setOrderShippingAddressMutation =
        await getSdk().setOrderShippingAddress(input)
      await mutate(ACTIVE_ORDER_KEY)

      return setOrderShippingAddressMutation
    },
    [mutate]
  )

  return { setOrderShippingAddress }
}
